/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Eye(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Eye',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 15 * scale,
      viewBox: '0 0 15 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M7.502 3C3.91 3 1 7.44 1 7.44S3.91 12 7.502 12C11.09 12 14 7.44 14 7.44S11.09 3 7.502 3m0 8a3.5 3.5 0 0 1 0-7A3.5 3.5 0 0 1 11 7.5C11 9.434 9.434 11 7.502 11m0-5.156a1.656 1.656 0 1 0-.003 3.31 1.656 1.656 0 0 0 .002-3.31z"}))
}
